export function buttonizeDiv(handlerFn) {
  return {
    role: 'button',
    onClick: handlerFn,
    onKeyDown: (event) => {
      // Only when the element itself has focus. Enter on a focused child
      // (e.g. a link inside a dropdown) already fires its own click, which
      // bubbles up to onClick — handling it here too would fire twice.
      if (event.key === 'Enter' && event.target === event.currentTarget) {
        handlerFn(event);
      }
    },
  };
}
